/* eslint-disable */
/**
 * Quick links to AI features, scoped to the current project.
 * Used in ProjectDetail (InnerHeader) and as a compact dropdown.
 */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  Typography,
  useTheme,
} from "@mui/material";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const AI_LINKS = [
  { path: "/ai-content-strategy", label: "Content Strategy", icon: AutoFixHighIcon },
  { path: "/ai-autopilot", label: "SEO Autopilot", icon: SmartToyIcon },
  { path: "/ai-ab-testing", label: "A/B Testing", icon: CompareArrowsIcon },
];

export default function AiToolsQuickLinks({ projectId, buttonLabel = "AI Tools", size = "medium" }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const goTo = (path) => {
    const url = projectId ? `${path}?projectId=${projectId}` : path;
    navigate(url);
    handleClose();
  };

  if (!projectId) return null;

  return (
    <>
      <Button
        variant="contained"
        endIcon={<KeyboardArrowDownIcon />}
        onClick={handleClick}
        size={size}
        sx={{
          textTransform: "none",
          backgroundColor: theme.palette.primary.main,
          color: "#fff",
          "&:hover": { backgroundColor: theme.palette.primary.dark },
        }}
      >
        {buttonLabel}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: { minWidth: 220, mt: 1.5 },
        }}
      >
        <Box sx={{ px: 2, py: 1, borderBottom: `1px solid ${theme.palette.divider}` }}>
          <Typography variant="caption" color="text.secondary">
            AI features for this website
          </Typography>
        </Box>
        <List dense>
          {AI_LINKS.map(({ path, label, icon: Icon }) => (
            <ListItemButton key={path} onClick={() => goTo(path)}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <Icon fontSize="small" color="primary" />
              </ListItemIcon>
              <ListItemText primary={label} />
            </ListItemButton>
          ))}
        </List>
      </Menu>
    </>
  );
}
